/* global $ */

require('nestable2');

const Nestable = {
  /**
   * Create
   * @return {void}
   */
  create(node, props) {
    this.$nestable = $(node);

    this.options = props;

    this.$nestable.nestable({
      maxDepth: typeof this.options.nestableDepth !== 'undefined' ? this.options.nestableDepth : 1,
    })
      .on('change', this.onNestingChange.bind(this));
  },

  /**
   * Callback that is called after a nesting change
   * @return {void}
   */
  onNestingChange() {
    const items = this.$nestable.nestable('serialize');
    const data = { items };

    if (typeof this.options.nestableMethod !== 'undefined') {
      data._method = this.options.nestableMethod; // eslint-disable-line no-underscore-dangle
    }

    window.axios.post(this.options.nestableApi, data)
      .catch((/* err */) => {
        // console.error(err);
      });
  },
};

export default Nestable;
